import {mapMutations} from "vuex";
import {SET_DETAIL_ITEM, SHOW_DIALOG} from "@/store/mutations.type";

/**
 * Adds showMeasurementListDialog Method to any component to display the current logs measurment list
 * <button @click="measurementListDialog">{{ $t('button.measurementList') }}</button>
 */
export default {
	methods: {
		...mapMutations([SHOW_DIALOG]),
		showMeasurementListDialog(log, isVirtual, watchlistItem) {
			if (typeof log !== "undefined") {
				this.$store.commit(SET_DETAIL_ITEM, log);
			}

			this[SHOW_DIALOG]({
				component: 'MeasurementList',
				isVirtual,
				watchlistItem
			});
		}
	}
}